// src/app/components/toast/toast.component.ts
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService,ToastMessage } from '../../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, OnDestroy {
  isVisible = false;
  message: string = '';
  type: 'success' | 'error' = 'success';

  private toastSubscription!: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastSubscription = this.toastService.toast$.subscribe(
      (toast: ToastMessage | null) => {
        if (toast) {
          this.message = toast.message;
          this.type = toast.type;
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
    }
  }

  hide() {
    this.toastService.hide();
  }
}